<template>
  <div class="config-panel">
    <!-- 标签页 -->
    <div class="config-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        @click="setActiveTab(tab.key)"
        :class="['tab-btn', { active: activeTab === tab.key }]"
      >
        <span class="tab-icon">{{ tab.icon }}</span>
        <span class="tab-label">{{ tab.label }}</span>
      </button>
    </div>

    <!-- 标签内容 -->
    <div class="tab-content">
      <!-- 基础配置 -->
      <div v-if="activeTab === 'basic'" class="config-content">
        <BasicConfig />
      </div>
      
      <!-- 样式配置 -->
      <div v-if="activeTab === 'style'" class="config-content">
        <StyleConfig />
      </div>
      
      <!-- 高级配置 -->
      <div v-if="activeTab === 'advanced'" class="config-content">
        <AdvancedConfig />
      </div>
      
      <!-- 元素属性 -->
      <div v-if="activeTab === 'element'" class="config-content">
        <ElementConfig />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import BasicConfig from './config/BasicConfig.vue'
import StyleConfig from './config/StyleConfig.vue'
import AdvancedConfig from './config/AdvancedConfig.vue'
import ElementConfig from './config/ElementConfig.vue'

export default {
  name: 'ConfigPanel',
  components: {
    BasicConfig,
    StyleConfig,
    AdvancedConfig,
    ElementConfig
  },
  
  setup() {
    const store = useStore()
    
    const tabs = [
      { key: 'basic', label: '基础', icon: '📄' },
      { key: 'style', label: '样式', icon: '🎨' },
      { key: 'advanced', label: '高级', icon: '⚙️' },
      { key: 'element', label: '元素', icon: '🔧' }
    ]
    
    const activeTab = computed(() => store.state.template.activeTab || 'basic')
    
    const setActiveTab = (tab) => {
      store.dispatch('template/setActiveTab', tab)
    }
    
    return {
      tabs,
      activeTab,
      setActiveTab
    }
  }
}
</script>

<style scoped>
.config-panel {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.config-tabs {
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.tab-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
}

.tab-btn:hover {
  background: #e9ecef;
}

.tab-btn.active {
  background: #fff;
  border-bottom-color: #667eea;
  color: #667eea;
}

.tab-icon {
  font-size: 18px;
  margin-bottom: 4px;
}

.tab-label {
  font-size: 12px;
  font-weight: 500;
}

.tab-content {
  flex: 1;
  overflow-y: auto;
}

.config-content {
  padding: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .tab-btn {
    padding: 8px 4px;
  }
  
  .tab-icon {
    font-size: 16px;
  }
  
  .tab-label {
    font-size: 11px;
  }
  
  .config-content {
    padding: 16px;
  }
}
</style>
